import { Link } from "react-router-dom";
import { useMediaPredicate } from "react-media-hook";
import {
  portfolio_projects,
  FUTURE_DEVELOPMENT_STATES,
} from "../data/portfolioProjects";

// Only ever needs to cover the states that actually show up below — not a
// full 50-state table.
const STATE_ABBREVIATIONS = {
  Georgia: "GA",
  Maryland: "MD",
  Virginia: "VA",
  Texas: "TX",
  "New York": "NY",
};

// Derived from the same portfolio_projects.js the real /portfolio map reads
// (order of first appearance — Georgia, Maryland, Virginia today), plus the
// same FUTURE_DEVELOPMENT_STATES PortfolioMap.js flags on its map, instead
// of hand-maintaining a second/third copy of either list.
const STATES_WITH_LOCATIONS = [
  ...new Set(portfolio_projects.map((p) => p.state).filter(Boolean)),
].map((state) => ({ state, isFuture: false }));

const STATES = [
  ...STATES_WITH_LOCATIONS,
  ...FUTURE_DEVELOPMENT_STATES.map((state) => ({ state, isFuture: true })),
];

const hasFutureStates = STATES.some((s) => s.isFuture);

// Text-based replacement for the old HomeStatesMap corner map — same corner
// placement over the hero carousel and the same "jump to the full
// portfolio" click behavior, without the map/topojson weight. Hidden on
// mobile for the same reason the map was: no room for a corner module once
// the hero drops to a single narrow column.
export default function HomeStatesHighlight() {
  const isMobile = useMediaPredicate("(max-width: 900px)");

  if (isMobile) return null;

  return (
    <Link
      to="/portfolio"
      className="home-states-highlight"
      data-testid="home-states-highlight"
    >
      <div className="home-states-highlight-row">
        <p className="home-states-highlight-label">Where We Build</p>
        <ul className="home-states-highlight-list">
          {STATES.map(({ state, isFuture }) => (
            <li
              key={state}
              className={`home-states-highlight-item ${
                isFuture ? "home-states-highlight-item-future" : ""
              }`}
            >
              {STATE_ABBREVIATIONS[state] || state}
              {isFuture && "*"}
            </li>
          ))}
        </ul>
      </div>
      {hasFutureStates && (
        <p className="home-states-highlight-legend">*Future development</p>
      )}
    </Link>
  );
}
